import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { useClickToTextPageContext } from 'pages/clickToText/context'
import { ClickToTextTable } from 'pages/clickToText/pages/all/ui'
import { useClickToTextListContext } from 'pages/clickToText/pages/all/context'
import { Search } from 'pages/clickToText/pages/all/ui/ClickToTextTable/Search/Search'
import { EmptyStateClickToText } from '../EmptyStateClickToText/EmptyStateClickToText'
import { ClickToTextListHeader } from './ClickToTextListHeader'
import styles from './styles.module.scss'

export const ClickToTextListContent = observer(() => {
  const { isClickToTextEmpty, isInitialLoading, loadClickToText } = useClickToTextListContext()
  const { pageLayoutStore, isClickToTextActionShown, isDetailsModalOpen } =
    useClickToTextPageContext()

  useEffect(() => {
    void loadClickToText()
  }, [])

  if (isInitialLoading) {
    return <SpinnerLoader ariaLabel={'ClickToTextListContent'} />
  }

  if (isClickToTextEmpty) {
    return <EmptyStateClickToText />
  }

  return (
    <>
      <ClickToTextListHeader
        title={isDetailsModalOpen ? 'Click & Scan QR' : 'Click to text'}
        pageLayoutStore={pageLayoutStore}
        isClickToTextActionShown={isClickToTextActionShown}
      />
      <div className={styles.listContentContainer}>
        <Search />
        <ClickToTextTable />
      </div>
    </>
  )
})
